const genEnum = require('./enum')
const customEnum = require('./customEnum')
module.exports = {
  ...genEnum,
  ...customEnum,
}
